import { useEffect, useState, useRef } from "react";
import { getTableParticipants } from "@/Services/EventMeetingServices";

/**
 * Polls: GET /sessions/:sessionId/tables/:tableId/participants
 * Uses axiosInstance (handles auth automatically)
 */
export function useTableRosterPolling({
    sessionId,
    tableId,
    pollMs = 2000,
}) {
    const [tableRoster, setTableRoster] = useState(null);
    const inFlightRef = useRef(false);
    const cancelledRef = useRef(false);

    useEffect(() => {
        if (!sessionId || !tableId) {
            setTableRoster(null);
            return;
        }

        cancelledRef.current = false;
        inFlightRef.current = false;

        const fetchRoster = async () => {
            if (inFlightRef.current) return;
            inFlightRef.current = true;

            try {
                const result = await getTableParticipants(sessionId, tableId);

                if (!cancelledRef.current) {
                    // handle both { data: ... } and direct array/object responses
                    const roster = result?.data ?? result ?? null;
                    setTableRoster(roster);
                }
            } catch (e) {
                if (!cancelledRef.current) {
                    console.error("Failed to fetch table participants:", e);
                }
            } finally {
                inFlightRef.current = false;
            }
        };

        fetchRoster();
        const id = setInterval(fetchRoster, pollMs);

        return () => {
            cancelledRef.current = true;
            clearInterval(id);
        };
    }, [sessionId, tableId, pollMs]);

    return tableRoster;
}